import React, { FunctionComponent } from 'react';
import styled from 'styled-components';

import { Modal } from 'components';
import GovernmentChargesRow from './GovernmentChargesRow';

const Table = styled.table`
  width: 100%;
  td,
  th {
    padding: 1px 10px;
    font-size: 16px;
    text-align: right;
  }

  td[scope],
  th[scope] {
    font-weight: 700;
  }

  td: first-child, th: first-child {
    padding-left: 0;
    border-left: none;
    font-weight: 700;
    text-align: left;
  }
`;

export const shouldDisplayGovernmentCharge = (
  monthCost: number,
  yearCost: number
): boolean => monthCost > 0 && yearCost > 0;

export const GovernmentChargesModal: FunctionComponent<{
  isOpen: boolean;
  onClose: () => void;
  gst: string;
  sd: string;
  fsl: string;
}> = ({ isOpen, onClose, gst, sd, fsl }) => (
  <Modal header="Government Charges" isOpen={isOpen} onClose={onClose}>
    <Table>
      <tbody>
        <GovernmentChargesRow title="GST" value={gst} />
        <GovernmentChargesRow title="Stamp Duty" value={sd} />
        {parseFloat(fsl) > 0 && (
          <GovernmentChargesRow
            title="Fire/Emergency Services Levy"
            value={fsl}
          />
        )}
      </tbody>
    </Table>
  </Modal>
);

export default GovernmentChargesModal;
